import React from "react";
import { KuikaSkeletonDetail, KuikaSkeletonRegion } from "../../ui-kit/kuika-skeleton/kuika-skeleton";

export interface HelpdeskTicketSkeletonProps {
  /** Off while the ticket list beside it is loading too, so the page says "Loading" once. */
  announce?: boolean;
}

/** The ticket panel while a ticket has none of its own data on screen yet. */
const HelpdeskTicketSkeleton = ({ announce = true }: HelpdeskTicketSkeletonProps): React.ReactElement => (
  <div className="kuika-helpdesk-viewer">
    <KuikaSkeletonRegion
      label="Loading ticket"
      announce={announce}
      className="kuika-helpdesk-viewer__skeleton"
      data-testid="helpdeskTicketSkeleton"
    >
      <KuikaSkeletonDetail />
    </KuikaSkeletonRegion>
  </div>
);

export default HelpdeskTicketSkeleton;
